import { useContext, useEffect, useMemo } from 'react';
import { substituteParams, useAPI } from '../../state';
import { OrgConfigWizardContext } from './context';
var ORG_CONFIG_VERSION_ENSURE_API = '/api/orgConfig/version/ensureWorking';
var ORG_CONFIG_VERSION_CURRENT_API = '/api/orgConfig/version/current';
var ORG_CONFIG_VERSION_FINALIZE_API = '/api/orgConfig/version/finalize';
var ORG_CONFIG_LOCATIONS_API = '/api/orgConfig/locations';
var ORG_CONFIG_LOCATION_DETAIL_API = '/api/orgConfig/locations/{id}';
var ORG_CONFIG_SHRINKAGE_API = '/api/orgConfig/locations/{locationId}/shrinkage';
var ORG_CONFIG_SHRINKAGE_COPY_API = '/api/orgConfig/locations/{locationId}/shrinkage/copyFrom/{sourceLocationId}';
var ORG_CONFIG_SHRINKAGE_STATUS_API = '/api/orgConfig/locations/shrinkage/status';
export var useOrgConfigVersionAPI = function () {
    return useAPI(ORG_CONFIG_VERSION_ENSURE_API, {}, 'POST', { key: 'orgConfigVersion' });
};
export var useCurrentVersionAPI = function () {
    return useAPI(ORG_CONFIG_VERSION_CURRENT_API, {}, 'GET', {
        key: 'orgConfigVersionCurrent',
    });
};
export var useFinalizeVersionAPI = function () {
    return useAPI(ORG_CONFIG_VERSION_FINALIZE_API, {}, 'POST', { key: 'orgConfigVersionFinalize' });
};
export var useLocationsAPI = function (configVersionId) {
    return useAPI("".concat(ORG_CONFIG_LOCATIONS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigLocations-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useCreateLocationAPI = function () { return useAPI(ORG_CONFIG_LOCATIONS_API, {}, 'POST'); };
export var useUpdateLocationAPI = function (id) {
    return useAPI(substituteParams(ORG_CONFIG_LOCATION_DETAIL_API, { id: id || 0 }), { id: id || 0 }, 'PUT', {
        key: "orgConfigLocationUpdate-".concat(id),
    });
};
export var useDeleteLocationAPI = function (id) {
    return useAPI(substituteParams(ORG_CONFIG_LOCATION_DETAIL_API, { id: id }), { id: id }, 'DELETE', {
        key: "orgConfigLocationDelete-".concat(id),
    });
};
export var useLocationDetailAPI = function (id) {
    return useAPI(substituteParams(ORG_CONFIG_LOCATION_DETAIL_API, { id: id !== null && id !== void 0 ? id : 0 }), { id: id !== null && id !== void 0 ? id : 0 }, 'GET', {
        key: id == null ? 'orgConfigLocation-none' : "orgConfigLocation-".concat(id),
    });
};
export var useShrinkageConfigAPI = function (locationId) {
    return useAPI(substituteParams(ORG_CONFIG_SHRINKAGE_API, { locationId: locationId !== null && locationId !== void 0 ? locationId : 0 }), { locationId: locationId !== null && locationId !== void 0 ? locationId : 0 }, 'GET', { key: locationId == null ? 'orgConfigShrinkage-none' : "orgConfigShrinkage-".concat(locationId) });
};
/** Redux api slice key for {@link useSaveShrinkageAPI} (matches useAPI client key + method). */
export var orgConfigShrinkageSaveApiKey = function (locationId) { return "orgConfigShrinkageSave-".concat(locationId, ":PUT"); };
export var useSaveShrinkageAPI = function (locationId) {
    return useAPI(substituteParams(ORG_CONFIG_SHRINKAGE_API, { locationId: locationId }), { locationId: locationId }, 'PUT', {
        key: "orgConfigShrinkageSave-".concat(locationId),
    });
};
/** PUT shrinkage for any location — pass `locationId` as the second argument to the request function. */
export var useShrinkagePutAPI = function () {
    return useAPI(ORG_CONFIG_SHRINKAGE_API, {}, 'PUT', {
        key: 'orgConfigShrinkagePut',
    });
};
export var useCopyShrinkageFromAPI = function (locationId, sourceLocationId) {
    return useAPI(substituteParams(ORG_CONFIG_SHRINKAGE_COPY_API, { locationId: locationId, sourceLocationId: sourceLocationId !== null && sourceLocationId !== void 0 ? sourceLocationId : 0 }), { locationId: locationId, sourceLocationId: sourceLocationId !== null && sourceLocationId !== void 0 ? sourceLocationId : 0 }, 'POST', { key: "orgConfigShrinkageCopy-".concat(locationId, "-").concat(sourceLocationId !== null && sourceLocationId !== void 0 ? sourceLocationId : 'none') });
};
export var useShrinkageStatusAPI = function (configVersionId) {
    return useAPI("".concat(ORG_CONFIG_SHRINKAGE_STATUS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "shrinkageStatus-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useConfiguredLocationIds = function (fetchStatus, statusData) {
    var configVersionId = useContext(OrgConfigWizardContext).configVersionId;
    useEffect(function () {
        if (configVersionId)
            fetchStatus();
    }, [configVersionId, fetchStatus]);
    var configuredLocationIds = useMemo(function () {
        var ids = new Set();
        if (statusData.data) {
            for (var _i = 0, _a = statusData.data; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.hasConfig)
                    ids.add(item.locationId);
            }
        }
        return ids;
    }, [statusData.data]);
    return configuredLocationIds;
};
